module.exports = __webpack_public_path__ + "static/media/bannar-pc.d1259345.png";